import Carousel from "./core_modules/carousel"

class App {
    private body = document.body
    private header = document.querySelector("[data-header]") as HTMLElement
    private headerIntersect = document.querySelector("[data-observer-intercept]") as HTMLElement
    private navToggleButton = document.querySelector("[data-toggle]")
    private navBar = document.querySelector("[data-nav]")
    private navBarList = document.querySelector(".navBarList")
    private navBarListItem = Array.from(document.querySelectorAll(".navBarListItem"))
    private navBarDropdownListItem = Array.from(document.querySelectorAll(".navBarDropdownListItem"))
    private productChoices = Array.from(document.querySelectorAll('.choices'))



    constructor() {
        this.initApp()
        const carousel = new Carousel('.carousel-slides')
    }

    /* Register your functions here */
    private initApp(): void {
        this.body.style.overflowX = 'hidden';
        this.navToggleButton?.addEventListener("click", this.handleNavigationToggle.bind(this))
        this.setHeaderShadow()
        this.handleActiveLinkOnclick()
        this.handleActiveLinkOnPageLoad()
        this.handleProductChoiceClick()
        
    }

    /**
     * @function HELPER
     * @returns { string }
     * @description Current page url string
     */
    get getCurrentPage(): string {
        return window.location.pathname;
    }

    /**
     * @function HELPER
     * @param listItem 
     * @param classList
     * @description Adds active state class to list item element 
     */
    private setActiveLink(listItem: Element, classList: string): void {
        const listItemLink = listItem.querySelector("a")?.getAttribute("href")
        if (listItemLink === this.getCurrentPage) {
            listItem.classList.add(classList)
            listItem.closest(".navBarListItem") && listItem.closest(".navBarListItem")?.classList.add(classList)
        }

        if (listItemLink?.includes('blog') && this.getCurrentPage.includes('blog')) {
            listItem.classList.add(classList)
            listItem.closest(".navBarListItem") && listItem.closest(".navBarListItem")?.classList.add(classList)
        }
    }

    private setHeaderShadow(): void {

        /* The callback that will fire on intersection */
        const onIntersect = (entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                this.header.toggleAttribute("data-header-box-shadow", !entry.isIntersecting)

            });
        }

        const observer = new IntersectionObserver(onIntersect)

        observer.observe(this.headerIntersect)
    }

    // FUNCTION DECLARATIONS
    private handleNavigationToggle(): void {
        this.navBar?.toggleAttribute("data-menu-open")
        this.navBar?.setAttribute("aria-expanded", "")
        this.body.removeAttribute('style')
        if (this.navBar?.hasAttribute("data-menu-open")) {
            this.navBar.setAttribute("aria-expanded", "true")
            this.navToggleButton?.setAttribute("aria-expanded", "true")
            this.body.style.overflow = "hidden"
        } else {
            this.navBar?.setAttribute("aria-expanded", "false")
            this.navToggleButton?.setAttribute("aria-expanded", "false")
            this.body.removeAttribute('style')
            this.body.style.overflowX = "hidden"
        }
    }

    private handleActiveLinkOnPageLoad(): void {
        this.navBarListItem.forEach(listItem => {
            this.setActiveLink(listItem, "active");
        })

        this.navBarDropdownListItem.forEach(listItem => {
            this.setActiveLink(listItem, "active")
        })
    }

    private handleActiveLinkOnclick(): void {
        this.navBarList?.addEventListener("click", (e) => {
            // store the target value in a variable
            const target = e.target as HTMLAnchorElement;

            // get target attribute for current page
            const currentPage = target.getAttribute("href");

            // show the navbar menu
            target.nextElementSibling?.toggleAttribute("data-dropdown-menu")

            // If link is already active on page load, move on.
            if (target.closest(".navBarListItem")?.classList.contains("active")) return

            // clear the active state if no link is already active on page load
            this.navBarListItem.forEach(listItem => listItem.classList.remove("active"));
            this.navBarDropdownListItem.forEach(listItem => listItem.classList.remove("active"));

            // check the parent element of target value and add active state to the parent when clicked
            // TODO: check if target href attribute matches current page url
            if (target.closest(".navBarListItem") && currentPage === this.getCurrentPage) {
                target.closest(".navBarListItem")?.classList.add("active")
            }

            if (target.closest(".navBarDropdownListItem") && currentPage === this.getCurrentPage) {
                target.closest(".navBarDropdownListItem")?.classList.add("active")
            }
        })
    }

    private handleProductChoiceClick(): void {
        this.productChoices.forEach(choice => {
            choice.addEventListener("click", (evt) => {
                const target = evt.target as HTMLElement
                const current = target.closest(".choice")?.querySelector(".input-outlined.active")
                if (current?.classList.contains("active")) {
                    current.classList.remove("active")
                }

                target.classList.add("active")

                if (current?.classList.contains("active")) {
                    current.classList.remove("active")
                }
            })

        })

    }

}

export const myApp = new App();